export default [
  {
    key: "increasement",
    sortable: true,
    sortField: "createdAt",
    label: "label.no",
    thClass: "w-50px",
  },
  {
    key: "name",
    sortable: true,
    sortField: "firstName",
    label: "field.employeeName",
    stickyColumn: true,
    variant: "light",
  },
  {
    key: "isActive",
    sortable: false,
    sortField: "isActive",
    label: "field.status",
  },
  {
    key: "department",
    sortable: false,
    sortField: "department",
    label: "field.department",
  },
  {
    key: "projects",
    sortable: false,
    sortField: "projects",
    label: "breadcrumb.project",
  },
  {
    key: "isManager",
    sortable: false,
    sortField: "isManager",
    label: "field.role",
  },
  {
    key: "workSchedule",
    sortable: false,
    sortField: "workSchedule",
    label: "breadcrumb.workingSchedule",
  },
  {
    key: "serviceCap",
    sortable: false,
    sortField: "serviceCap",
    label: "field.serviceCap",
  },
  {
    key: "totalServiceWork",
    sortable: false,
    sortField: "totalServiceWorked",
    label: "field.currentActiveService",
  },
  {
    key: "createdAt",
    sortable: true,
    sortField: "createdAt",
    label: "field.createDate",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
